const validateConfig = (): void => {
  if (!process.env.REACT_APP_SF_BASE_URL) {
    throw new Error('REACT_APP_SF_BASE_URL is required')
  }
  if (!process.env.REACT_APP_SF_CALLBACK_URL) {
    throw new Error('REACT_APP_SF_CALLBACK_URL is required')
  }
  if (!process.env.REACT_APP_SF_CLIENT_ID) {
    throw new Error('REACT_APP_SF_CLIENT_ID is required')
  }
  if (!process.env.REACT_APP_SF_SECRET) {
    throw new Error('REACT_APP_SF_SECRET is required')
  }
}

validateConfig()

const config = {
  sfcall: {
    BASE_URL: process.env.REACT_APP_SF_BASE_URL!,
    CALLBACK_URL: process.env.REACT_APP_SF_CALLBACK_URL!,
    CLIENT_ID: process.env.REACT_APP_SF_CLIENT_ID!,
    SECRET: process.env.REACT_APP_SF_SECRET!,
  },
}

export {config}
